interface Props {
  [key: string]: any
}

export default function HomRightArrowIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M9 5l7 7-7 7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}
